export default function useProfile(){
    const token=localStorage.getItem("privateToken")
    const userDetails= JSON.parse(localStorage.getItem("studentData"))
    return { token , userDetails}
}